/** Stable id for Holdings “View all” sheet heading + dialog labelling (HoldingViewall_B02/B04/B08). */
export const HOLDINGS_VIEW_ALL_HEADING_ID = 'holdings-view-all-heading'

export const HOLDINGS_VIEW_ALL_TAB_PANEL_ID = 'holdings-view-all-tab-panel'
